angular.module('dnecom')
    .controller('StoreCustomScriptsMobileSettingsController', ["$scope", "StoreUtils", "IntegrationsUtils", "notifications", "wizardModal", "$http", function ($scope, StoreUtils, IntegrationsUtils, notifications, wizardModal, $http) {
        $scope.accounts = [];

        IntegrationsUtils.getAccountsByTypes(function (accounts) {
            if (!_.isEmpty(accounts) && accounts.facebookpixel) {
                $scope.accounts = accounts.facebookpixel;
            }
        });
    }]);
